module.exports = window["wc"]["productEditor"];